import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading, selectUserData } from "../../redux/state/authReduser/authentification.selectors";
import { Box, Slide, useTheme } from "@mui/material";
import { fetchUser } from "../../redux/state/authReduser/services";
import { scrollToTop } from "../../srevices/scrollToTop";
import ProfileInfo from "../../Components/ProfileInfo/ProfileInfo";
import ProfileStats from "../../Components/ProfileStats/ProfileStats";
import ProfileOrdersButton from "../../Components/ProfileOrdersButton/ProfileOrdersButton";
import profileStyles from "./Profile.styles";
import Loader from "../../Components/Loader/Loader";
import Home from "../Home/Home";

const Profile = () => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const theme = useTheme();
  const styles = profileStyles(theme);
  const isLoading = useSelector(selectIsLoading)


  useEffect(() => {
    scrollToTop();
    dispatch(fetchUser());
  }, [dispatch]);

  if (isLoading) <Loader/>
  if (!userData) return <Home/>;

  return (
    <Slide direction="left" in timeout={1000}>
      <Box sx={styles.container}>
        <Box sx={styles.card}>
          <ProfileInfo username={userData.username} email={userData.email} />
          <ProfileStats balance={userData.balance} discount={userData.discount} orderCount={userData.orderHistory?.length} />
          <ProfileOrdersButton />
        </Box>
      </Box>
    </Slide>
  );
};

export default Profile;
